import { yup } from '@comptia-sso/core';

export const validationSchema = yup.object().shape({
  comptiaId: yup.string().required('Required'),
  pearsonVueId: yup.string().required('Required'),
});
